// Fatia S1: confirma o e-mail ao abrir o link.
import { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { api } from '../../lib/api'
import { useSession } from '../../lib/session'
import AuthShell, { FormError, FormOk } from '../../features/auth/AuthShell'
import { linkErrorMessage } from '../../features/auth/link-errors'
import { Loading } from '../../ui'

export default function VerifyEmail() {
  const { token = '' } = useParams()
  const { me, refresh } = useSession()
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading')
  const [error, setError] = useState<string | null>(null)
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    api.post('/auth/verify-email', { token })
      .then(async () => { setState('ok'); await refresh() })
      .catch((err) => { setError(linkErrorMessage(err, 'Este link de confirmação não vale mais. Ele pode ter expirado ou já ter sido usado.')); setState('error') })
  }, [token, refresh])

  return (
    <AuthShell title="Confirmação de e-mail">
      {state === 'loading' && <Loading lines={2} />}
      {state === 'ok' && (
        <div className="stack" style={{ gap: 14 }}>
          <FormOk>Pronto! Seu e-mail foi confirmado.</FormOk>
          <Link className="btn primary lg block" to={me ? '/app' : '/login'}>{me ? 'Ir para o painel' : 'Entrar'}</Link>
        </div>
      )}
      {state === 'error' && (
        <div className="stack" style={{ gap: 14 }}>
          <FormError error={error} />
          <p className="small muted">Você pode pedir um novo link em “Meu perfil e segurança”, dentro do painel.</p>
          <Link className="btn block" to={me ? '/app/perfil' : '/login'}>{me ? 'Abrir meu perfil' : 'Entrar'}</Link>
        </div>
      )}
    </AuthShell>
  )
}
